import { 
  FETCH_DASHBOARD_SUCCESS_ACTION ,
  FETCH_TRIP_DATA_SUCCESS_ACTION
} from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_DASHBOARD_SUCCESS_ACTION:
      return {
        ...state,
        dashboardDtlsList: action.payload
      };
      case FETCH_TRIP_DATA_SUCCESS_ACTION:
        return {
          ...state,
          tripdataList: action.payload.rows,
          tripdatacount: action.payload.count
        };
    default:
      return {
        ...state
      };
  }
}
